import styled from 'styled-components';

export const HipagesLogo = styled.img`
  width: 223px;
`;

export const NSWGovernmentLogoImg = styled.img`
  width: 88px;
  margin-left: 1rem;
`;

export const LogoZone = styled.div`
  margin-top: 4rem;
  margin-bottom: 2rem;
`;
